export function ensureTaskIds(schedule) {
    if (schedule?.tasks) {
        schedule.tasks.forEach((task) => {
            task.taskId ??= task.id
        })
    }
    return schedule
}
